(function () {
    "use strict";

    angular.module("app").controller("OrganisationPhysicalInstallationsController", OrganisationPhysicalInstallationsController);

    OrganisationPhysicalInstallationsController.$inject = ["controllerDecorator", "physicalInstallation", "habilDate"];
    function OrganisationPhysicalInstallationsController(controllerDecorator, physicalInstallation, habilDate) {
        const context = {};

        const vm = this;

        controllerDecorator.Decorate(vm, ["navigation"]);

        vm.GetStyle = getStyle;

        function initialize() {
            context.DossierId = vm.ParseUrl().parameters.dossierid;

            physicalInstallation.GetSecuredZonesForOrganisation(
                context.DossierId,
                r => vm.Installations = r.data,
                vm.ShowError
            );
        }

        initialize();

        function getStyle(installation) {
            if (!installation.ApprovedUntil)
                return "";

            const expiration = habilDate.GetDateOnly(installation.ApprovedUntil);
            const today = habilDate.GetDateOnly(new Date());

            if (expiration.valueOf() < today.valueOf())
                return "overview-expired";

            const oneYearFromNow = habilDate.GetDateOnly(new Date()).setFullYear(today.getFullYear() + 1);
            if (expiration.valueOf() < oneYearFromNow.valueOf())
                return "overview-expiring";

            return "overview-valid";
        }
    }
})();